<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">CBA Sucre</div>

          <div class="card-body">
            <div class="row">
              <div class="col">
                <h4>Bienvenido</h4>
              </div>
            </div>
            <!-- Administración y secretaria -->
            <CRow
              v-auth-roles="{
                user: userAuth,
                roles: [roles.ROLE_ADMINISTRATOR, roles.ROLE_SECRETARY],
              }"
            >
              <CCol sm="12" lg="4">
                <router-link
                  to="/reportes/horarios"
                  custom
                  v-slot="{ href, navigate }"
                >
                  <a :href="href" @click="navigate">
                    <CWidgetSimple header="VER" text="HORARIOS">
                    </CWidgetSimple>
                  </a>
                </router-link>
              </CCol>
              <CCol sm="12" lg="4">
                <router-link
                  to="/reportes/deuda-pensiones"
                  custom
                  v-slot="{ href, navigate }"
                >
                  <a :href="href" @click="navigate">
                    <CWidgetSimple header="VER" text="PENSIONES POR COBRAR">
                    </CWidgetSimple>
                  </a>
                </router-link>
              </CCol>
              <CCol sm="12" lg="4">
                <router-link
                  to="/reportes/recaudaciones"
                  custom
                  v-slot="{ href, navigate }"
                >
                  <a :href="href" @click="navigate">
                    <CWidgetSimple header="VER" text="RECAUDACIONES">
                    </CWidgetSimple>
                  </a>
                </router-link>
              </CCol>
            </CRow>
            <CRow
              v-auth-roles="{
                user: userAuth,
                roles: [roles.ROLE_ADMINISTRATOR, roles.ROLE_SECRETARY, roles.ROLE_SYSTEM],
              }"
            >
              <CCol sm="12" lg="4">
                <router-link
                  to="/reportes/calificaciones-por-periodo"
                  custom
                  v-slot="{ href, navigate }"
                >
                  <a :href="href" @click="navigate">
                    <CWidgetSimple
                      header="VER"
                      text="CALIFICACIONES DE CURSOS POR PERIODO"
                    >
                    </CWidgetSimple>
                  </a>
                </router-link>
              </CCol>
              <CCol sm="12" lg="4">
                <router-link
                  to="/reportes/estadistica-generales-por-periodo"
                  custom
                  v-slot="{ href, navigate }"
                >
                  <a :href="href" @click="navigate">
                    <CWidgetSimple
                      header="VER"
                      text="ESTADISTICAS GENERALES POR PERIODOS"
                    >
                    </CWidgetSimple>
                  </a>
                </router-link>
              </CCol>
              <CCol sm="12" lg="4">
                <router-link
                  to="/reportes/estudiantes-programados"
                  custom
                  v-slot="{ href, navigate }"
                >
                  <a :href="href" @click="navigate">
                    <CWidgetSimple
                      header="VER"
                      text="ESTUDIANTES PROGRAMADOS"
                    >
                    </CWidgetSimple>
                  </a>
                </router-link>
              </CCol>
            </CRow>
            <!-- Estudiantes -->
            <CRow
              v-auth-roles="{
                user: userAuth,
                roles: [roles.ROLE_STUDENT],
              }"
            >
              <CCol sm="12" lg="3">
                <router-link to="/kardex" custom v-slot="{ href, navigate }">
                  <a :href="href" @click="navigate">
                    <CWidgetSimple header="VER" text="KARDEX"> </CWidgetSimple>
                  </a>
                </router-link>
              </CCol>
              <CCol sm="12" lg="3">
                <router-link to="/libreta" custom v-slot="{ href, navigate }">
                  <a :href="href" @click="navigate">
                    <CWidgetSimple header="VER" text="LIBRETA"> </CWidgetSimple>
                  </a>
                </router-link>
              </CCol>
              <CCol sm="12" lg="3">
                <router-link
                  to="/programaciones"
                  custom
                  v-slot="{ href, navigate }"
                >
                  <a :href="href" @click="navigate">
                    <CWidgetSimple header="VER" text="PROGRAMACIONES">
                    </CWidgetSimple>
                  </a>
                </router-link>
              </CCol>
              <CCol sm="12" lg="3">
                <router-link to="/pensiones" custom v-slot="{ href, navigate }">
                  <a :href="href" @click="navigate">
                    <CWidgetSimple header="VER" text="PENSIONES">
                    </CWidgetSimple>
                  </a>
                </router-link>
              </CCol>
            </CRow>
            <!-- Profesores -->
            <CRow
              v-auth-roles="{
                user: userAuth,
                roles: [roles.ROLE_TEACHER],
              }"
            >
              <CCol sm="12" lg="6">
                <router-link
                  to="/cursos-ofertados-profesor"
                  custom
                  v-slot="{ href, navigate }"
                >
                  <a :href="href" @click="navigate">
                    <CWidgetSimple header="VER" text="CURSOS ASIGNADOS">
                    </CWidgetSimple>
                  </a>
                </router-link>
              </CCol>
              <CCol sm="12" lg="6">
                <router-link
                  to="/horarios-profesor"
                  custom
                  v-slot="{ href, navigate }"
                >
                  <a :href="href" @click="navigate">
                    <CWidgetSimple header="VER" text="HORARIOS ASIGNADOS">
                    </CWidgetSimple>
                  </a>
                </router-link>
              </CCol>
            </CRow>
            <!-- Sistema -->
            <CRow
              v-auth-roles="{
                user: userAuth,
                roles: [roles.ROLE_SYSTEM],
              }"
            >
              <CCol sm="12" lg="6">
                <router-link
                  to="/estudiantes"
                  custom
                  v-slot="{ href, navigate }"
                >
                  <a :href="href" @click="navigate">
                    <CWidgetSimple header="VER" text="ESTUDIANTES">
                    </CWidgetSimple>
                  </a>
                </router-link>
              </CCol>
              <CCol sm="12" lg="6">
                <router-link to="/usuarios" custom v-slot="{ href, navigate }">
                  <a :href="href" @click="navigate">
                    <CWidgetSimple header="VER" text="USUARIOS">
                    </CWidgetSimple>
                  </a>
                </router-link>
              </CCol>
            </CRow>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Constants from "@/plugins/constants";
export default {
  data() {
    return {
      roles: Constants.roles,
    };
  },
  mounted() {},
  computed: {
    userAuth() {
      return this.$store.state.userAuth;
    },
  },
  methods: {
    toSchedule() {},
  },
};
</script>
